import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { EvaluatorService, IEvaluatorUpdateStatusPayload } from 'src/app/core/services/evaluator.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluatorActionsService {

  constructor(private evaluatorService: EvaluatorService) { }

  public handleEvaluatorUpdateStatus(id: number | string, data: IEvaluatorUpdateStatusPayload) {
    const body: IEvaluatorUpdateStatusPayload = {
      evalStatus: data.evalStatus,
      reasonForChange: data.reasonForChange,
      nonCompliantType: data.nonCompliantType
    }
    return this.evaluatorService.evaluatorUpdateStatus(id, body).pipe(take(1));
  }


}
